import { ma } from 'moving-averages';
import { isEmpty } from 'lodash';
import { MOVING_AVERAGE_SIZE_MULTIPLIER } from 'constants/report';
import { DATE_FORMAT_NO_TIME_ZONE } from 'constants/config';
import momentTz from 'moment-timezone';
import { flattenKeyPairArray } from 'utils/misc';
import moment from 'moment';
import millify from './millify';

/* eslint-disable import/prefer-default-export */
export const movingAverage = (graphData, dataKey) => {
  let dataKeyData = graphData ? graphData.map(data => data[dataKey]) : null;

  if (!isEmpty(dataKeyData)) {
    dataKeyData = ma(dataKeyData, dataKeyData.length * MOVING_AVERAGE_SIZE_MULTIPLIER);
    dataKeyData = dataKeyData.filter(data => data !== null).map(data => (
      { [dataKey]: data }
    ));
  }
  return dataKeyData;
};

export const getTimezoneAndUTCOffset = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcoffset = momentTz.tz(momentTz(), timezone).format('Z');
  return { timezone, utcoffset };
};

export const formatPotentialReach = potentialReach => String(millify(parseInt(potentialReach, 10))).toUpperCase();

/* eslint-disable no-param-reassign */
export const prepareFilterParams = (params) => {
  const prepParams = { ...params };
  // in API we will consume accounts as string ( 'accountID1, accountID2' )

  prepParams.campaign__id = flattenKeyPairArray(prepParams.campaign__id || [], 'value');
  prepParams.product__id = flattenKeyPairArray(prepParams.product__id || [], 'value');
  prepParams.account__id = flattenKeyPairArray(prepParams.account__id || [], 'value');
  prepParams.sequences__id = flattenKeyPairArray(prepParams.sequences__id || [], 'value');
  prepParams.campaign_status = flattenKeyPairArray(prepParams.campaign_status || [], 'value');
  prepParams.subscription_type__id = flattenKeyPairArray(prepParams.subscription_type__id || [], 'value');
  prepParams.email_service_provider_config__id = flattenKeyPairArray(
    prepParams.email_service_provider_config__id || [],
    'value',
  );
  prepParams.campaign__campaign_manager__id =
    flattenKeyPairArray(prepParams.campaign__campaign_manager__id || [], 'value');

  // round date to dates with UTC
  prepParams.start_date = moment(prepParams.startDate).startOf('day').format(DATE_FORMAT_NO_TIME_ZONE);
  prepParams.end_date = moment(prepParams.endDate).endOf('day').format(DATE_FORMAT_NO_TIME_ZONE);
  if (prepParams.lastPeriodStartDate && prepParams.lastPeriodEndDate) {
    prepParams.last_period_start_date = moment(prepParams.lastPeriodStartDate)
      .startOf('day')
      .format(DATE_FORMAT_NO_TIME_ZONE);
    prepParams.last_period_end_date = moment(prepParams.lastPeriodEndDate)
      .endOf('day')
      .format(DATE_FORMAT_NO_TIME_ZONE);
  }
  delete prepParams.startDate;
  delete prepParams.endDate;
  delete prepParams.lastPeriodStartDate;
  delete prepParams.lastPeriodEndDate;
  delete prepParams.dateSelector;
  return prepParams;
};

export const percentageChange = (initial, current) => {
  initial = parseFloat(initial);
  current = parseFloat(current);

  if (!initial || !current) {
    return 'NA';
  }

  return ((current - initial) / initial) * 100;
};

export const formatNumber = num => num.toLocaleString();
